(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-ft3-language]').forEach(select => {
      if (select.dataset.bound) return;
      select.dataset.bound = 'true';
      select.addEventListener('change', () => select.form.requestSubmit());
    });
    const search = root.querySelector('[data-ft3-faq-search]');
    if (search && !search.dataset.bound) {
      search.dataset.bound = 'true';
      search.addEventListener('input', () => {
        const term = search.value.trim().toLocaleLowerCase();
        let visible = 0;
        root.querySelectorAll('[data-ft3-faq]').forEach(item => {
          item.hidden = !item.textContent.toLocaleLowerCase().includes(term);
          if (!item.hidden) visible++;
        });
        root.querySelector('[data-ft3-faq-empty]').hidden = visible > 0;
      });
    }
    root.querySelectorAll('.ft3-mobile-menu').forEach(menu => {
      if (menu.dataset.bound) return;
      menu.dataset.bound = 'true';
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { menu.open = false; menu.querySelector('summary').focus(); }
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
